import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo" aria-label="ProgrammoCeuticals home">
          <span className="logo-primary">Programmo</span>
          <span className="logo-secondary">Ceuticals</span>
        </Link>
        
        <div className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <Link to="/products" className="nav-link" onClick={() => setIsOpen(false)}>
            Products
          </Link>
          <Link to="/services" className="nav-link" onClick={() => setIsOpen(false)}>
            Services
          </Link>
          <Link to="/about" className="nav-link" onClick={() => setIsOpen(false)}>
            About
          </Link>
          <Link to="/contact" className="nav-cta" onClick={() => setIsOpen(false)}>
            Contact Us
          </Link>
        </div>
        
        <div className="nav-toggle" onClick={() => setIsOpen(!isOpen)}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
